import { connect } from 'react-redux';
import { toggleFeedbackPage, toggleBurgerMenuRequested, openNotificationsDropdown, closeNotificationsDropdown, } from '../../redux/actions';
import { getFeedbackCount } from '../../../publicSession/selectors';
import { getIsFeedbackPageOpen, getIsNotificationsDropdownOpen, } from '../../redux/selectors';
var mapStateToProps = function (state) { return ({
    isFeedbackPageOpen: getIsFeedbackPageOpen(state),
    isNotificationsDropdownOpen: getIsNotificationsDropdownOpen(state),
    feedbackCount: getFeedbackCount(state),
}); };
var mapDispatchToProps = {
    toggleFeedbackPage: toggleFeedbackPage,
    toggleBurgerMenu: toggleBurgerMenuRequested,
    openNotificationsDropdown: openNotificationsDropdown,
    closeNotificationsDropdown: closeNotificationsDropdown,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=NotificationsDropdownWrapper.container.js.map